export const shiphawkAccionesRoles = {
  sideNavActions: {
    shiphawkGenerateExcel: ['Chief', 'Shiphawk'],
  },
};
